<template>
  <bvue-ui-view class="flex flex-col w-full" :scroll="true">
    <h1 class="flex-1">Serial</h1>
    <div class="form-group flex-1">
      <label>Serial</label>
      <input type="text" class="form-input" v-model="item.ticket" />
    </div>
    <div class="form-group flex-1">
      <label>Donante</label>
      <input type="text" class="form-input" v-model="item.user" />
    </div>
    <div class="form-group flex-1">
      <label>Estado</label>
      <input type="text" class="form-input" v-model="item.status" />
    </div>
    <div class=" flex my-4 justify-end">
      <div>
        <button @click="store" :class="['btn', 'btn-primary', loading]">{{isNew ? 'Crear' : 'Guardar'}}</button>
      </div>
    </div>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
export default {
  name: 'SerialesDetails',
  components: {  },
  props: {
    modalData: Object
  },
  data() {
    return {
      isNew: true,
      loading: [],
      item: {}
    }
  },
  methods: {
    async store() {
      this.loading = ['loading', 'disabled']
      const collection = firebase.firestore.collection('seriales')
      var item = this.item
      const id = this.item.id
      delete item.id
      await collection.doc(id).set(item)
      this.loading = []
      this.$bvueUi.modal.close()
    }
  },
  created() {
    console.log('this.modalData: ', this.modalData)
    if (this.modalData && this.modalData.id) {
      this.isNew = false
      this.item = this.modalData
    } else {
      this.item.id = firebase.firestore.collection('seriales').doc().id
    }
    console.log('this.item: ', this.item)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/SerialesDetails.vue